import Image from 'next/image';
import classNames from 'classnames';
import { SearchItemWithImageViewModel } from '@/types/api';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { NavigationCarousel } from '@/features/carousel';
import { EasyAccess } from '@/features/tag';
import { handleImageError } from '@/utils/image-error';
import MobileSearchLink from './mobile-search-link';
import { SuggestionType } from './types';
interface Props {
  title: string;
  children?: React.ReactElement;
  items: SearchItemWithImageViewModel[] | null;
  perView: number | 'auto';
  dataTest: string;
  type?: SuggestionType;
  queryId?: string | null;
  className?: string;
}
const Suggestions = ({
  title,
  children,
  items,
  perView,
  dataTest,
  type,
  queryId,
  className
}: Props) => {
  return items?.length ? <div className={classNames('flex w-full flex-col gap-4 rounded-md bg-white pb-2 pt-6 text-text-black first-of-type:!pt-0 lg:mt-0 lg:px-1', className)} data-sentry-component="Suggestions" data-sentry-source-file="suggestions.tsx">
            <div className='flex flex-row items-center pr-2'>
                {children}
                <span className='text-sm font-bold lg:text-base'>{title}</span>
            </div>

            <div className='flex flex-col items-start gap-4 overflow-auto lg:overflow-hidden lg:pl-0' data-test={`search-result--${dataTest}`}>
                <NavigationCarousel className='flex' options={{
        perView,
        spacing: type === SuggestionType.Products ? 6 : 4,
        mode: 'free'
      }} data-sentry-element="NavigationCarousel" data-sentry-source-file="suggestions.tsx">
                    {items.map(item => <div key={item.id} className={classNames('keen-slider__slide max-w-fit', !item?.imageUrl && 'w-full min-w-fit overflow-visible whitespace-nowrap')}>
                            {item?.imageUrl ? <MobileSearchLink className={classNames('flex h-full w-full items-center justify-between gap-2 rounded border border-border-gray-medium text-center font-medium transition-all duration-100 hover:border-brand-secondary hover:bg-surface-solid-0', items.length < 2 && 'max-w-fit', item?.imageUrl ? 'bg-surface-solid-0 p-1' : 'bg-surface-solid-50 px-2 py-1')} href={getSearchResultItemURL(item)} item={item} queryId={queryId || ''}>
                                    <Image unoptimized src={item.imageUrl} alt={item.nameFa || ''} width={55} height={55} className='h-14 w-14 lg:h-16 lg:w-16' onError={handleImageError} />
                                    <span className={classNames('grow text-center text-xs lg:text-sm', item?.imageUrl ? 'line-clamp-2 text-right' : 'text-text-darkGray')}>
                                        {item.nameFa}
                                    </span>
                                </MobileSearchLink> : <EasyAccess size='medium' href={getSearchResultItemURL(item)} marketing={{
            term: item.nameFa || '',
            elementTrackingId: 'cta_click',
            elementType: 'Search-MostPopularTerms',
            elementName: 'Search-MostPopularTerms',
            elementIndex: (item?.position ?? 0) + 1
          }}>
                                    {item.nameFa}
                                </EasyAccess>}
                        </div>)}
                </NavigationCarousel>
            </div>
        </div> : null;
};
export default Suggestions;